export default "__VITE_ASSET__CVamDQpu__"